// extracted by mini-css-extract-plugin
export default {"hamburgerContainer":"hamburger-button_hamburgerContainer__hRU9+","extraMargin":"hamburger-button_extraMargin__gQQja","active":"hamburger-button_active__KsEBY"};